"use client";
import { ReactNode } from "react";
import SiteChrome from "../components/SiteChrome";

export default function LoginLayout({ children }: { children: ReactNode }) {
  return <SiteChrome>{children}</SiteChrome>;
}
